var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512"}},_vm.$listeners),[_c('path',{attrs:{"d":"M424 168H23.1C9.9 168 0 178.8 0 191.1 0 205.2 10.8 216 23.1 216H424c13.2 0 24-10.8 24-23.1 0-14.1-10.8-24.9-24-24.9zm0 128H23.1C9.9 296 0 306.8 0 319.1S10.8 344 23.1 344H424c13.2 0 24-10.8 24-23.1S437.2 296 424 296z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }